import React, { useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

function Map() {
  useEffect(() => {
    // Crea una mappa e la centra su una posizione specifica
    const map = L.map('map').setView([45.77940637606446, 11.767863080870491], 16);

    // Aggiungi un layer di OpenStreetMap con uno stile diverso
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution: '<a href="https://www.openstreetmap.org/copyright"> © OpenStreetMap</a> contributors <a href="https://carto.com/attributions">© CARTO</a>'
    }).addTo(map);

    // Crea un'icona personalizzata per il marker con colore rosso
    const redIcon = new L.Icon({
      iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 38],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });

    // Aggiungi un marker alla mappa con l'icona rossa
    L.marker([45.77940637606446, 11.767863080870491], { icon: redIcon }).addTo(map)
      .bindPopup(`
        <div class="custom-popup">
          <h4>Andolfatto Insurance Broker</h4>
        </div>
      `);

    // Modifica gli stili dei pulsanti di zoom utilizzando JavaScript
    const zoomInButton = document.querySelector('.leaflet-control-zoom-in');
    const zoomOutButton = document.querySelector('.leaflet-control-zoom-out');

    if (zoomInButton && zoomOutButton) {
      // Imposta lo stile dei pulsanti di zoom
      zoomInButton.style.backgroundColor = '#8c2b45';
      zoomInButton.style.color = 'white';
      zoomInButton.style.width = '30px';
      zoomInButton.style.height = '30px';
      zoomInButton.style.lineHeight = '30px';
      zoomInButton.style.textAlign = 'center';
      zoomInButton.style.borderRadius = '4px';
      zoomInButton.style.cursor = 'pointer';
      zoomInButton.style.display = 'flex';
      zoomInButton.style.justifyContent = 'center';
      zoomInButton.style.alignItems = 'center';

      zoomOutButton.style.backgroundColor = '#8c2b45';
      zoomOutButton.style.color = 'white';
      zoomOutButton.style.width = '30px';
      zoomOutButton.style.height = '30px';
      zoomOutButton.style.lineHeight = '30px';
      zoomOutButton.style.textAlign = 'center';
      zoomOutButton.style.borderRadius = '4px';
      zoomOutButton.style.cursor = 'pointer';
      zoomOutButton.style.display = 'flex';
      zoomOutButton.style.justifyContent = 'center';
      zoomOutButton.style.alignItems = 'center';

      // Centra i simboli "+" e "-" nei pulsanti di zoom
      const zoomInButtonInner = zoomInButton.querySelector('a');
      const zoomOutButtonInner = zoomOutButton.querySelector('a');

      if (zoomInButtonInner && zoomOutButtonInner) {
        zoomInButtonInner.style.display = 'flex';
        zoomInButtonInner.style.justifyContent = 'center';
        zoomInButtonInner.style.alignItems = 'center';
        zoomInButtonInner.style.height = '100%';

        zoomOutButtonInner.style.display = 'flex';
        zoomOutButtonInner.style.justifyContent = 'center';
        zoomOutButtonInner.style.alignItems = 'center';
        zoomOutButtonInner.style.height = '100%';
      }
    }
    
    // Modifica il colore del testo e dei link nel riquadro degli attributi
    const attributionControl = document.querySelector('.leaflet-control-attribution');
    if (attributionControl) {
      attributionControl.style.color = '#8c2b45';
      const links = attributionControl.querySelectorAll('a');
      links.forEach(link => {
        link.style.color = '#8c2b45';
      });
    }


    // Pulizia della mappa quando il componente viene smontato
    return () => {
      map.remove();
    };
  }, []);

  return (
    <>
      <div id="map" style={{ height: '250px', width: '100%' }}></div>
      <style jsx>{`
        .custom-popup h4 {
          color: #8c2b45;
          margin: 5px 0 0 0;
          font-size: 14px;
        }
        .custom-popup p {
          color: #333;
          margin: 0;
          font-size: 14px;
        }
        .leaflet-popup-content-wrapper {
          border-radius: 10px;
          padding: 15px;
        }
        .leaflet-popup-content {
          margin: 0;
        }
      `}</style>
    </>
  );
}

export default Map;
